<template>
  <div class="search">
      search
      {{house.city}}
      {{house.zipCode}}
  </div>
</template>

<script>
export default {
  name: 'Search',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      house : {
        city: null,
        zipCode: null,
      },
    }
  },
  watch: {
    '$route' (to, from) {
      this.house.city = to.query.city;
      this.house.zipCode = to.query.zipCode;
    }
  },
  mounted () {
    this.house.city = this.$route.query.city;
    this.house.zipCode = this.$route.query.zipCode;
    // axios.post('api/house/listbycondition?page=1',this.house)
    // .then(res =>{
    //     console.log(res);
    // }).catch(err => {
    //     console.log(err);
    // })
    apiInRentHouse()
    .then(res =>{
        // console.log(res);
    }).catch(err => {
        console.log(err);
    })
  },
  methods: {
    updateArea: function (obj) {
      // `this` inside methods points to the Vue instance
      // console.log('Hello ' + this.msg + '!')
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Search.vue